import { GtmTracker } from '@/modules/common/services/analytics';
import { IInvestmentSuggestionProduct } from '@/modules/wealth/services/investment';

const trackEvent = GtmTracker.trackerWithDefaultProps({
  page_screen: 'portfolio_withdrawal_suggestion'
});

export function trackLoadProductDetails(product: IInvestmentSuggestionProduct) {
  trackEvent({
    event_type: 'load',
    event_name: 'view_instrument_suggestion',
    instrument_name: product.productName,
    withdrawal_value: product.amount.value
  });
}

export function trackAcceptRedeemSuggestion(value: number) {
  trackEvent({
    event_type: 'click',
    event_name: 'accept_withdrawal_suggestion',
    withdrawal_value: value
  });
}

export function trackRefuseRedeemSuggestion(value: number) {
  trackEvent({
    event_type: 'click',
    event_name: 'refuse_withdrawal_suggestion',
    withdrawal_value: value
  });
}

export function trackRedeemSuccessful() {
  GtmTracker.trackEvent({
    page_screen: 'portfolio_instrument_withdrawal_request_success',
    event_type: 'load',
    event_name: 'view',
    page_screen_section: 'withdrawal_requested'
  });
}
